var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-wrap"},[(_vm.pageState === 2)?_c('AddCourse',{ref:"addCourse",attrs:{"schoolYearList":_vm.schoolYearListTwo,"semesterList":_vm.semesterList,"courseRangeList":_vm.gradeList,"gradeSysList":_vm.gradeSysList}}):_vm._e(),(_vm.pageState === 3)?_c('ViewResults',{attrs:{"taskId":_vm.taskId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }